module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "value-form-slug"
  }, [_vm._v("\n  " + _vm._s(_vm.value) + "\n  "), _c('a', {
    staticClass: "icon yule-icon-external-link",
    attrs: {
      "target": "_blank",
      "href": _vm.url
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47a2f0f8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataDisplay/CollectionValues/CollectionValueFormSlug.vue
// module id = 1890
// module chunks = 0